<script>
import ApiService from "@/service/api.service"
import Services from "@/service/Services"
import Swal from "sweetalert2";
import CryptoJS from 'crypto-js';
import { 
  ArrowUpIcon,
  VideoIcon,
  MailIcon,
  UserIcon,
  KeyIcon,
  PhoneIcon,
  MapPinIcon } 
  from "vue-feather-icons";

import { 
  Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";
import Pricing from "@/components/pricing";

/**
 * Index-software component
 */
export default {
  data() {
    return {
      solutionList: [
        {
          icon: 'uil uil-thumbs-up',
          title: 'Experience and Expertise',
          text: 'Our team of skilled developers has years of experience in web and mobile application development. We are well-versed in a wide range of technologies, frameworks, and platforms, including but not limited to HTML5, CSS3, JavaScript, React, Angular, Flutter, iOS, and Android. We stay up-to-date with the latest industry trends to deliver cutting-edge solutions to our clients.'
        },
         {
          icon: 'uil uil-edit-alt',
          title: 'Customized Solutions',
          text: 'We understand that every project is unique, and we take pride in tailoring our solutions to meet your specific requirements. Whether you need a simple website, a complex web application, or a feature-rich mobile app, we have the expertise to deliver a customized solution that meets your business goals.'
        },
         {
          icon: 'uil  uil-stopwatch',
          title: 'Timely Delivery',
          text: 'At Reliable Web & Mobile Application Developer, we value your time. We follow a streamlined development process and set realistic deadlines to ensure that your project is delivered on time, without compromising on quality. We keep you updated with regular progress reports and are always available to address any concerns or queries you may have.'
        },
         {
          icon: 'uil uil-tag-alt',
          title: 'Competitive Pricing',
          text: 'We offer competitive pricing for our services, without compromising on quality. Our goal is to provide you with the best value for your investment, and we work closely with you to ensure that our solutions fit within your budget.'
        },
         {
          icon: 'uil uil-shield-check',
          title: 'Excellent Support',
          text: 'Our relationship with our clients does not end with the delivery of the project. We provide reliable and prompt support even after the project is completed. Our team is available to address any post-development issues, provide maintenance services, and offer updates and enhancements as needed.'
        },
         
      ],
      formItem: {
        name: '',
        email: '',
        password: '',
        number: '',
        address: ''
      },
      defaultItem: {
        name: '',
        email: '',
        password: '',
        number: '',
        address: ''
      }
    };
  },
  
    methods : {
    converterBe(date){
      var conv_date = new Date(date);
      var dd = String(conv_date.getDate()).padStart(2, '0');
      var mm = String(conv_date.getMonth() + 1).padStart(2, '0'); 
      var yyyy = conv_date.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    CreateDataUser(data_save){
      return new Promise(resolve => {
        var mydata = {}
        mydata = Object.assign({}, data_save)
        mydata.Trigger = 'C'
        mydata.Route = 'regis_from_landingpage'
        mydata.level = 1
        mydata.app_category_id = 'asiatech_base'
        mydata.is_activated = 0
        mydata.limit_users = -1
        mydata.join_date = this.converterBe(Date.now())
        mydata.url = "register-"+ new Date().getTime() + ".com"
        mydata.password = CryptoJS.SHA256(data_save.password).toString()
        Services.PostData(ApiService, "profile", mydata, async response=>{
          // var responseStatus = response.status
          if(response.status == 1000){
              Swal.fire({
                text: "Form has been successfully submitted!",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              })
              this.formItem = Object.assign({}, this.defaultItem)
            }else{
              Swal.fire({
                text: "Sorry, looks like there are some errors detected, please try again.",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            }
          }, err =>{
          err
          })
        });
      },
    },

  components: {
    Navbar,
    Switcher,
    Footer,
    Carousel,
    Pricing,
    Slide,
    ArrowUpIcon,
    VideoIcon,
    MailIcon,
    UserIcon,
    KeyIcon,
    PhoneIcon,
    MapPinIcon
  },
};
</script>

<template>
  <div style="background-color: #FFFFFF;">
    <Navbar :nav-light="true" />
    <section
      class="bg-half-170 pb-0 bg-primary d-table w-100"
      style="background: url('images/img-cover3.png') center center; height: 1183px;"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="col-6 col-6">
            <div class="title-heading pr-0">
              <!-- <h4 class="text-white-50">We are creative</h4> -->
              <!-- <h4 class="heading text-white mb-3 title-dark">
                Best IT Solution <br />
                Company
              </h4> -->
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
              <p class=" para-desc text-muted-50">
                Are you in need of a skilled and trustworthy web and mobile application developer? Look no further! <br/><br/>
Our team of experts at Asiatech Inti Raya are here to provide you with top-notch solutions for all your web and mobile application development needs.
              </p>
              <div class="mt-4 pt-2">
                <a href="javascript:void(0);" class="btn btn-light"  v-scroll-to="'#product'"
                  >Get Started</a
                >
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-6 mt-5 mt-sm-0">
            <img src="images/hero1.png" class="img-fluid" alt="" />
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Section Start -->
    <section class="section pt-md-4 pt-5">
      <!-- Start Features -->
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-left">
            <span class="badge badge-pill badge-primary mb-4 mt-4">Why Choose Asiatech</span>
            <div class="section-title mb-4 pb-2">
              <h5 class="title mb-4">Reliable Web & Mobile Application Developer is your go-to partner for all your web and mobile application development projects. <br>Here's why you should choose us:</h5>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <div class="col-md-4 col-12 mt-5" v-for="(item,index) of solutionList" :key="index">
            <div class="features text-left">
              <div class="image position-relative d-inline-block">
                <i :class="`${item.icon} h1 text-primary`"></i>
              </div>

              <div class="content mt-4">
                <h5>{{item.title}}</h5>
                <p class="text-muted mb-0">
                  {{item.text}}
                </p>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <!-- <div class="row justify-content-center mt-5 pt-4">
          <div class="col-lg-10 col-md-12">
            <img
              src="images/software/mobile-hori.png"
              class="img-fluid d-block mx-auto"
              alt=""
            />
          </div> -->
          <!--end col-->
          <!-- <div class="col-12 text-center pt-2">
            <div class="alert alert-light alert-pills shadow" role="alert">
              <span class="badge badge-pill badge-primary mr-1">Download</span>
              <span class="content">
                Trusted by the world's best <i class="mdi mdi-download"></i
              ></span>
            </div>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->
      </div>
        </section>
      <!--end container-->
      <!-- End Features -->

      <!-- <div class="container mt-100 mt-60"> -->
        <!-- <div class="card rounded bg-light shadow border-0">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-sm-7">
                <div class="text-sm-left">
                  <h5 class="mb-0">
                    Start building beautiful block-based websites.
                  </h5>
                </div>
              </div> -->
              <!--end col-->

              <!-- <div class="col-sm-5 mt-4 mt-sm-0">
                <div class="text-sm-right">
                  <a href="javascript:void(0)" class="btn btn-outline-primary"
                    ><i class="mdi mdi-file-document-outline"></i> Start Now
                  </a>
                </div>
              </div> -->
              <!--end col-->
            <!-- </div> -->
            <!--end row -->
          <!-- </div> -->
        <!-- </div> -->
      <!-- </div> -->
      <!--end container-->

      <section class="section pt-md-4 pt-5" style="background-color: #F7F9FC;">
      <div class="container mt-100 mt-60">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="section-title mb-4 pb-2 text-center">
              <span class="badge badge-pill badge-primary mb-4 mt-4">Our Service</span>
              <h4 class="title mb-4">We’ve Developed Application Based on Your Needs</h4>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <div class="col-md-6 col-12 mt-4 pt-2">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <!-- <h5 class="mt-0">
                  How our <span class="text-primary">Landrick</span> work ? -->
                <!-- </h5> -->
                <p class="answer text-muted mb-0">
                  Fast-access information and user-friendly applications are the main focus in the development of the applications we create, so that you and your team can use them to support the operations of your organization and company.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-6 col-12 mt-4 pt-2">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <!-- <h5 class="mt-0">What is the main process open account ?</h5> -->
                <p class="answer text-muted mb-0">
                Accessing information anywhere and anytime, using available devices such as laptops at the office and home, as well as mobile applications on Android and iOS smartphones, so that you are not hindered in obtaining up-to-date information.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-6 col-12 mt-4 pt-2">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <!-- <h5 class="mt-0">How to make unlimited data entry ?</h5> -->
                <p class="answer text-muted mb-0">
                  Not only functional, but the user interface design also follows the latest trends, so that the application becomes easy and interactive to use in day-to-day operations, and the intuitive display of information supports you in decision-making.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->


        <!-- <div
          class="row my-md-5 pt-md-3 my-4 pt-2 pb-lg-5 mt-sm-0 pt-sm-0 justify-content-center"
        >
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title mb-4">Have Question ? Get in touch!</h4>
              <p class="text-muted para-desc mx-auto">
                Start working with
                <span class="text-primary font-weight-bold">Landrick</span> that
                can provide everything you need to generate awareness, drive
                traffic, connect.
              </p>
              <router-link to="/page-contact-two" class="btn btn-primary mt-4"
                ><i class="mdi mdi-phone"></i> Contact us</router-link
              >
            </div>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->
      </div>
      <!--end container-->

      

      <div class="container mt-100 mt-60">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <!-- <div class="section-title mb-5 pb-2">
              <h4 class="title mb-4">Transection Between Buyers and Seller</h4>
              <p class="text-muted para-desc mb-0 mx-auto">
                Start working with
                <span class="text-primary font-weight-bold">Landrick</span> that
                can provide everything you need to generate awareness, drive
                traffic, connect. -->
              <!-- </p>
            </div> -->
            <img
              src="images/mockupss.jpg"
              alt=""
              class="position-relative img-fluid mx-auto d-block"
              style="z-index: 1"
            />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      </section>


      

      <!-- <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div class="col-lg-5 col-md-6">
            <img src="images/software/mobile01.png" class="img-fluid" alt="" />
          </div> -->
          <!--end col-->

          <!-- <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="section-title ml-lg-5">
              <h4 class="title mb-4">
                Carry out Marketing Initiatives : Landrick
              </h4>
              <p class="text-muted">
                You can combine all the Landrick templates into a single one,
                you can take a component from the Application theme and use it
                in the Website.
              </p>
              <ul class="list-unstyled mb-0 text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Digital Marketing Solutions for Tomorrow
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Our Talented & Experienced Marketing Agency
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Create your own skin to match your brand
                </li>
              </ul>
            </div>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->
      <!-- </div> -->
      <!--end container-->

      <!-- Price Start -->
      <!-- <section class="section" style="background-color: #122D59; color: #fff;" id="service" >
      <div class="container mt-60 mt-60 mb-100">
        <div class="row justify-content-center">
          <div class="col-12 text-left">
            <div class="section-title mb-4 pb-2">
              <span class="badge badge-pill badge-primary mb-4 mt-4">Service & Planning</span>
              <h4 class="title mb-4">At Asiatech, we offer a wide range of services to cater to all your web and mobile application development needs. Our Service include:</h4>
            </div>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->

        <!-- <Pricing /> -->
        <!--end row-->
      <!-- </div> -->
      <!--end container-->
      <!-- Price End -->
      <!-- </section> -->

      <!-- How It Work Start -->
      <section class="section" style="background-color: #F7F9FC;" id="product">
      
        <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-4 ">
              <span class="badge badge-pill badge-primary mb-4 mt-4">Our Product</span>
              <h4 class="title mb-4">Revolutionize Your Tech Experience with Asiatech Inti Raya</h4>
              <p class="text-muted para-desc mx-auto mb-4">
                Unlock the Power of Innovation and Seamlessly Enhance Your Business Operations.
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div
            class="col-lg-6 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0"
          >
            <div class="section-title">
              <h4 class="title mb-4">
                SISFOLEG
              </h4>
              <p class="text-muted">
                SISFOLEG it’s a special application designed for legislative candidates in order to socialize citizens to be directed, measured and targeted with complete features.
              </p>
              <ul class="list-unstyled text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Cloud-based applications with reliable data locations
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Data synchronization in real time
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Statements of citizens organized according to RT/RW
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Monitoring of the area and the number of citizens supported
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Population expectations based on location
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Logistics for Support
                </li>
              </ul>
              <a href="https://sisfoleg.com/" class="btn btn-primary mt-3"
                >Go To Homepage <i class="mdi mdi-chevron-right"></i
              ></a>
            </div>
          </div>
          <!--end col-->
        <div class="col-lg-6 col-md-6 order-1 order-md-2">
            <img src="images/sisfoleg.jpg" class="img-fluid" alt="" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container" style="margin-top: 80px;">
        <div class="row align-items-center">
          <div class="col-lg-5 col-md-6">
            <img src="images/notasis.jpg" class="img-fluid" alt="" />
          </div>
          <!--end col-->


          <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="section-title ml-lg-5">
              <h4 class="title mb-4">
                Notasis
              </h4>
              <p class="text-muted">
                Notasis is an innovative application that fulfills the needs of modern notaries. We provide integrated solutions to accelerate the notarization process. Security and data privacy are our top priorities. Join us and experience the difference.
              </p>
              <ul class="list-unstyled text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Managing Deed Numbers
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Dashboard displaying data and job status
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Displaying schedules and task lists to facilitate work
                </li>
              </ul>
              <a href="http://notasis.id" class="btn btn-primary mt-3"
                >Go To Homepage <i class="mdi mdi-chevron-right"></i
              ></a>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      </div>
      <!--end container-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div
            class="col-lg-6 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0"
          >
            <div class="section-title">
              <h4 class="title mb-4">
                PingSmart
              </h4>
              <p class="text-muted">
                Technology for digital transformation in empowering education, enabling schools, students, teachers, and parents to connect, collaborate, and succeed together.
              </p>
              <ul class="list-unstyled text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Real-time attendance
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >School payments
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Online agenda assignments
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Integrated class schedules
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Location tracking for monitoring children's activities
                </li>
              </ul>
              <a href="https://pingsmart.id/" class="btn btn-primary mt-3"
                >Go To Homepage <i class="mdi mdi-chevron-right"></i
              ></a>
            </div>
          </div>
          <!--end col-->
        <div class="col-lg-6 col-md-6 order-1 order-md-2">
            <img src="images/pingsmart.jpg" class="img-fluid" alt="" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>


      
       <!-- <div class="container mt-100 mt-60" id="register">
        <div class="row align-items-center">
          <div
            class="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0"
          >
            <div class="section-title">
              <h4 class="title mb-4">
                Speed up your development <br />
                with <span class="text-primary">Asiatech Inti Raya</span>
              </h4> -->
              <!-- <p class="text-muted">
                Using Landrick to build your site means never worrying about
                designing another page or cross browser compatibility. Our
                ever-growing library of components and pre-designed layouts will
                make your life easier.
              </p> -->
              <!-- <ul class="list-unstyled text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Digital Marketing Solutions for Tomorrow
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Our Talented & Experienced Marketing Agency
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Create your own skin to match your brand
                </li>
              </ul> -->
              <!-- <a href="javascript: void(0);" class="mt-3 h6 text-primary"
                >Find Out More <i class="mdi mdi-chevron-right"></i
              ></a> -->
            <!-- </div>
          </div> -->
          <!--end col-->

          <!-- <div class="col-lg-5 col-md-6 order-1 order-md-2">
            <div class="card rounded border-0 shadow ml-lg-5">
              <div class="card-body" >
                <img
                  src="images/logo-warna.png" class="img-fluid"
                  alt=""
                />

                <div class="content mt-4 pt-2">
                  <form>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label
                            >Company Name : <span class="text-danger">*</span></label
                          >
                          <div class="position-relative">
                            <user-icon class="fea icon-sm icons"></user-icon>
                           <input
                                  v-model="formItem.name"
                                  name="name"
                                  id="name"
                                  type="text"
                                  class="form-control pl-5"
                                  placeholder="Company Name"
                                />
                          </div>
                        </div>
                      </div> -->
                      <!--end col-->

                      <!-- <div class="col-lg-12">
                        <div class="form-group">
                          <label
                            >Email : <span class="text-danger">*</span></label
                          >
                          <div class="position-relative">
                            <mail-icon class="fea icon-sm icons"></mail-icon>
                            <input
                                  v-model="formItem.email"
                                  name="email"
                                  id="email"
                                  type="email"
                                  class="form-control pl-5"
                                  placeholder="Email"
                                />
                          </div>
                        </div>
                      </div> -->
                      <!--end col-->

                      <!-- <div class="col-lg-12">
                        <div class="form-group">
                          <label
                            >Password :
                            <span class="text-danger">*</span></label
                          >
                          <div class="position-relative">
                            <key-icon class="fea icon-sm icons"></key-icon>
                            <input v-model="formItem.password" 
                            type="password" 
                            class="form-control pl-5" 
                            placeholder="Password" 
                            required=""
                            />
                          </div>
                        </div>
                      </div> -->

                      <!-- <div class="col-md-12">
                            <div class="form-group">
                              <label
                                >Phone<span class="text-danger"
                                  >*</span
                                ></label
                              >
                              <div class="position-relative">
                                <phone-icon
                                  class="fea icon-sm icons"
                                ></phone-icon>
                                <input
                                  v-model="formItem.number"
                                  name="number"
                                  id="number"
                                  type="number"
                                  class="form-control pl-5"
                                  placeholder="Phone"
                                />
                              </div>
                            </div>
                          </div> -->
                      <!--end col-->

                      <!-- <div class="col-md-12">
                      <div class="form-group">
                        <label>Address</label>
                        <div class="position-relative">
                          <map-pin-icon
                            class="fea icon-sm icons"
                          ></map-pin-icon>
                          <textarea
                            v-model="formItem.address"
                            name="address"
                            id="address"
                            rows="2"
                            class="form-control pl-5"
                            placeholder="Address"
                          ></textarea>
                        </div>
                      </div>
                    </div> -->

                    <!-- <div class="col-md-12">
                            <div class="form-group">
                              <div class="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="customCheck1"
                                />
                                <label
                                  class="custom-control-label"
                                  for="customCheck1"
                                  >I Accept
                                  <a href="#" class="text-primary"
                                    >Terms And Condition</a
                                  ></label
                                >
                              </div>
                            </div>
                          </div>

                      <div class="col-lg-12 mt-2 mb-0">
                        <button class="btn btn-primary btn-block" @click="CreateDataUser(formItem)">
                          Submit
                        </button>
                      </div> -->
                      <!--end col-->
                    <!-- </div> -->
                  <!-- </form>
                </div>
              </div>
            </div>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->
      <!-- </div> -->
      
    

      <!-- Start Testimonial -->
      <!-- <div class="container mt-100 mt-60">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Client Reviews</h4>
              <p class="text-muted para-desc mx-auto mb-0">
                Start working with
                <span class="text-primary font-weight-bold">Landrick</span> that
                can provide everything you need to generate awareness, drive
                traffic, connect.
              </p>
            </div>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->

        <!-- <div class="row justify-content-center">
          <div class="col-lg-12 mt-4">
            <carousel
              id="customer-testi"
              class="owl-carousel owl-theme"
              dir="ltr"
              :per-page="3"
              :loop="true"
            >
              <Slide>
                <div class="media customer-testi m-2">
                  <img
                    src="images/client/01.jpg"
                    class="avatar avatar-small mr-3 rounded shadow"
                    alt=""
                  />
                  <div
                    class="media-body content p-3 shadow rounded bg-white position-relative"
                  >
                    <ul class="list-unstyled mb-0">
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                    </ul>
                    <p class="text-muted mt-2">
                      " It seems that only fragments of the original text remain
                      in the Lorem Ipsum texts used today. "
                    </p>
                    <h6 class="text-primary">
                      - Thomas Israel <small class="text-muted">C.E.O</small>
                    </h6>
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="media customer-testi m-2">
                  <img
                    src="images/client/02.jpg"
                    class="avatar avatar-small mr-3 rounded shadow"
                    alt=""
                  /> -->
                  <!-- <div
                    class="media-body content p-3 shadow rounded bg-white position-relative"
                  >
                    <ul class="list-unstyled mb-0">
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star-half text-warning"></i>
                      </li>
                    </ul>
                    <p class="text-muted mt-2">
                      " One disadvantage of Lorum Ipsum is that in Latin certain
                      letters appear more frequently than others. "
                    </p>
                    <h6 class="text-primary">
                      - Barbara McIntosh <small class="text-muted">M.D</small>
                    </h6>
                  </div>
                </div>
              </Slide>
              <Slide> -->
                <!-- <div class="media customer-testi m-2">
                  <img
                    src="images/client/03.jpg"
                    class="avatar avatar-small mr-3 rounded shadow"
                    alt=""
                  />
                  <div
                    class="media-body content p-3 shadow rounded bg-white position-relative"
                  >
                    <ul class="list-unstyled mb-0">
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                    </ul>
                    <p class="text-muted mt-2">
                      " The most well-known dummy text is the 'Lorem Ipsum',
                      which is said to have originated in the 16th century. "
                    </p>
                    <h6 class="text-primary">
                      - Carl Oliver <small class="text-muted">P.A</small>
                    </h6>
                  </div>
                </div> -->
              <!-- </Slide>
              <Slide>
                <div class="media customer-testi m-2">
                  <img
                    src="images/client/04.jpg"
                    class="avatar avatar-small mr-3 rounded shadow"
                    alt=""
                  />
                  <div
                    class="media-body content p-3 shadow rounded bg-white position-relative"
                  >
                    <ul class="list-unstyled mb-0">
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                    </ul>
                    <p class="text-muted mt-2">
                      " According to most sources, Lorum Ipsum can be traced
                      back to a text composed by Cicero. "
                    </p>
                    <h6 class="text-primary">
                      - Christa Smith <small class="text-muted">Manager</small>
                    </h6>
                  </div>
                </div> -->
              <!-- </Slide>
              <Slide>
                <div class="media customer-testi m-2">
                  <img
                    src="images/client/05.jpg"
                    class="avatar avatar-small mr-3 rounded shadow"
                    alt=""
                  />
                  <div
                    class="media-body content p-3 shadow rounded bg-white position-relative"
                  >
                    <ul class="list-unstyled mb-0">
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                    </ul>
                    <p class="text-muted mt-2">
                      " There is now an abundance of readable dummy texts. These
                      are usually used when a text is required. "
                    </p>
                    <h6 class="text-primary">
                      - Dean Tolle <small class="text-muted">Developer</small>
                    </h6>
                  </div>
                </div>
              </Slide>
              <Slide> -->
                <!-- <div class="media customer-testi m-2">
                  <img
                    src="images/client/06.jpg"
                    class="avatar avatar-small mr-3 rounded shadow"
                    alt=""
                  />
                  <div
                    class="media-body content p-3 shadow rounded bg-white position-relative"
                  >
                    <ul class="list-unstyled mb-0">
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                      <li class="list-inline-item">
                        <i class="mdi mdi-star text-warning"></i>
                      </li>
                    </ul>
                    <p class="text-muted mt-2">
                      " Thus, Lorem Ipsum has only limited suitability as a
                      visual filler for German texts. "
                    </p>
                    <h6 class="text-primary">
                      - Jill Webb <small class="text-muted">Designer</small>
                    </h6>
                  </div>
                </div>
              </Slide>
            </carousel>
          </div> -->
          <!--end col-->
        <!-- </div> -->
        <!--end row-->
      <!-- </div> -->
      <!--end container-->
      <!-- End Testimonial -->
  
    <!--end section-->
    <!-- section End -->

    <!--  -->
    
    <section class="section mt-10 mt-60">
      <div class="container mt-10 mt-60" >
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title mb-4">
                Have Questions About Asiatech Inti Raya? <br>Contact Us!
              </h4>
              <p class="text-muted para-desc mx-auto mb-0">
                Start working with
                <span class="text-primary font-weight-bold">Asiatech Inti Raya</span> that
                can provide everything you need.
              </p>

              <div class="mt-4 pt-2">
                <a
                  href="mailto:info@asiatechintiraya.com"
                  target="_blank"
                  class="btn btn-primary"
                  >info@asiatechintiraya.com
                  </a
                >
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--  -->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- <Switcher /> -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style>
.modal-content {
  background-color: transparent;
}
</style>
